<div class="table-container" [class.globalAudit]="globalAudit">
    <div *ngIf="globalAudit" class="tab-header-button">
        <xp-download-status></xp-download-status>
        <button class="reset-button" mat-raised-button color="primary" (click)="resetFilters()">
            Reset Filters
        </button>
        <button mat-raised-button color="accent"
                [disabled]="downloadBusy || selectedCount === 0"
                (click)="downloadSelectedAsPdf()"
                matTooltip="Download the selected requests, on every page, as a ZIP of PDFs">
            <mat-icon>download</mat-icon>
            Download Selected ({{ selectedCount }})
        </button>
        <button mat-raised-button color="accent"
                [disabled]="downloadBusy || totalRows === 0"
                (click)="downloadAllAsPdf()"
                matTooltip="Download every request matching the current filters, on every page, as a ZIP of PDFs">
            <mat-icon>download</mat-icon>
            Download All
        </button>
    </div>

    <div class="grid-container">
        <div *ngIf="dataLoading" class="spinner">
            <mat-progress-spinner color="accent" mode="indeterminate" [diameter]="40"></mat-progress-spinner>
        </div>

        <ejs-grid #grid
                  [dataSource]="gridSource"
                  [allowPaging]="showPaginator()"
                  [pageSettings]="pageSettings"
                  [allowFiltering]="true"
                  [filterSettings]="filterSettings"
                  [allowSorting]="true"
                  [allowResizing]="true"
                  [allowSelection]="false"
                  [enableHover]="false"
                  [rowHeight]="36"
                  (rowDataBound)="rowDataBound($event)"
                  (actionComplete)="onActionComplete($event)"
                  (dataStateChange)="onDataStateChange($event)"
                  (recordClick)="onRecordClick($event)"
                  height="100%"
                  class="sync-grid">
            <e-columns>
                <e-column headerText="Select" width="70" freeze="Left" [visible]="globalAudit" [allowFiltering]="false" [allowSorting]="false">
                    <ng-template #headerTemplate>
                        <div class="header-select-checkbox">
                            <mat-checkbox [checked]="allSelected" [indeterminate]="someSelected" (change)="toggleSelectAll($event.checked)" matTooltip="Select every matching request, on all pages"></mat-checkbox>
                        </div>
                    </ng-template>
                    <ng-template #template let-data>
                        <mat-checkbox [checked]="isSelected(data)" (click)="onCheckboxClick($event, data)"></mat-checkbox>
                    </ng-template>
                </e-column>
                <e-column field="requestId" headerText="Request Id" width="110" textAlign="Right" [visible]="globalAudit" headerTextAlign="Left" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="requestTypeName" headerText="Request Type" width="140" [filter]="{ type: 'CheckBox' }" [visible]="globalAudit" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="stageName" headerText="Stage" width="160" [filter]="{ type: 'CheckBox' }" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="approvalStatus" headerText="Approval Status" width="180" [filter]="{ type: 'CheckBox' }" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="rpaStatus" headerText="RPA Status" width="130" [filter]="{ type: 'CheckBox' }" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="matterNo" headerText="Matter Number" width="130" textAlign="Right" [visible]="globalAudit" headerTextAlign="Left" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="matter" headerText="Matter" width="220" [visible]="globalAudit" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="clientName" headerText="Client" width="150" [visible]="globalAudit" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="partnerName" headerText="Partner" width="150" [visible]="globalAudit" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="createdDate" headerText="Created Date" width="180" type="date" clipMode="EllipsisWithTooltip" [format]="{ type: 'dateTime', format: 'dd/MM/yyyy HH:mm:ss' }" textAlign="Center">
                    <ng-template #template let-data>
                        {{ data.createdDate | date:'dd/MM/yyyy HH:mm:ss' }}
                    </ng-template>
                </e-column>
                <e-column field="createdByName" headerText="Created By" width="150" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="updatedDate" headerText="Updated Date" width="180" type="date" clipMode="EllipsisWithTooltip" [format]="{ type: 'dateTime', format: 'dd/MM/yyyy HH:mm:ss' }" textAlign="Center">
                    <ng-template #template let-data>
                        {{ data.updatedDate | date:'dd/MM/yyyy HH:mm:ss' }}
                    </ng-template>
                </e-column>
                <e-column field="updatedByName" headerText="Updated By" width="150" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="currencyCode" headerText="Currency" width="120" [filter]="{ type: 'CheckBox' }" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="amount" headerText="Amount" width="110" textAlign="Right" headerTextAlign="Left" clipMode="EllipsisWithTooltip">
                    <ng-template #template let-data>
                        {{ data.amount | number:'1.2-2' }}
                    </ng-template>
                </e-column>
                <e-column field="clientBankAccountName" headerText="Client Bank" [filter]="{ type: 'CheckBox' }" width="280" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="payee" headerText="Payee" width="130" [visible]="showPaymentBankColumns" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="bankName" headerText="Bank Name" width="130" [visible]="showPaymentBankColumns" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="sortCode" headerText="Sort Code" width="110" [visible]="showPaymentBankColumns" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="accountNumber" headerText="Account Number" width="140" [visible]="showPaymentBankColumns" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="rejectedReason" headerText="Rejected Reason" width="220" type="string" clipMode="EllipsisWithTooltip">
                    <ng-template #template let-data>
                        {{ data.rejectedReason == null || data.rejectedReason === '' ? 'N/A' : data.rejectedReason }}
                    </ng-template>
                </e-column>
                <e-column headerText="Actions" width="130" freeze="Right" [visible]="globalAudit" [allowFiltering]="false" [allowSorting]="false" textAlign="Center">
                    <ng-template #template let-data>
                        <div class="action-buttons">
                            <button (click)="viewAuditLogs(data)" mat-icon-button color="accent" matTooltip="View details">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button [disabled]="!data.documentAvailable" (click)="downloadDocuments(data.requestId, data.requestTypeName)" mat-icon-button color="accent" matTooltip="Download documents">
                                <mat-icon>download</mat-icon>
                            </button>
                        </div>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>

        <span class="no-data-message" *ngIf="noAuditData && !dataLoading && !loadError">No Audit logs found!</span>

        <xp-grid-load-error *ngIf="loadError && !dataLoading" message="The audit logs could not be loaded." (retry)="retryLoad()"></xp-grid-load-error>
    </div>
</div>
